module.exports = __webpack_public_path__ + "img/HK.2334830c.webp";